import { ArrowRight, Sparkles, Zap } from "lucide-react";
import { Button } from "./ui/button";

const BlogCTA = () => {
  return (
    <section className="relative overflow-hidden rounded-2xl border border-primary/20 bg-card my-12 animate-pulse-glow">
      <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-primary/15 blur-3xl animate-float" />
      <div className="absolute -left-16 -bottom-16 h-48 w-48 rounded-full bg-primary/10 blur-3xl animate-float" style={{ animationDelay: '3s' }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-32 w-32 rounded-full bg-primary/5 blur-2xl animate-float" style={{ animationDelay: '1.5s' }} />
      <div className="absolute top-0 left-0 right-0 h-px shimmer" />

      <div className="relative p-8 md:p-12 text-center max-w-2xl mx-auto">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-medium mb-6">
          <Zap className="h-3 w-3" /> Potencializado por IA
        </div>

        <h2 className="font-display text-2xl md:text-3xl font-extrabold text-foreground mb-4 leading-tight">
          Destrave sua fluência com{" "}
          <span className="gradient-text">Inteligência Artificial</span>
        </h2>
        <p className="text-muted-foreground mb-8 text-base md:text-lg leading-relaxed">
          Pratique conversação em inglês com IA avançada. Sem julgamento, sem horários fixos, no seu ritmo.
        </p>
        <Button
          asChild
          size="lg"
          className="bg-primary hover:bg-primary/90 text-primary-foreground font-bold px-8 rounded-full shadow-[0_0_25px_-5px_hsl(270_70%_55%/0.5)] hover:shadow-[0_0_35px_-5px_hsl(270_70%_55%/0.7)] transition-all duration-300 hover:scale-105"
        >
          <a href="https://www.ataric.com.br" target="_blank" rel="noopener noreferrer">
            <Sparkles className="mr-2 h-4 w-4" />
            Experimente grátis
            <ArrowRight className="ml-2 h-4 w-4" />
          </a>
        </Button>
      </div>
    </section>
  );
};

export default BlogCTA;
